export class CaseShort {
    CaseID: string = null;
    InsuredPersonName: string = null;
    CaseDate: string = null;
    TotalDocuments: Number = 0;
    TotalPhotos: Number = 0;

    public constructor(init?: Partial<CaseShort>) {
        Object.assign(this, init);
    }

    public resetCase(): void {
        this.CaseID = null;
        this.InsuredPersonName = null;
        this.CaseDate = null;
        this.TotalDocuments = 0;
        this.TotalPhotos = 0;
    }
}
